import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { omit, get } from 'lodash-es'
import { bindActionCreators } from 'redux'

class FeatureWrapperComponent extends React.Component {
  componentDidMount() {
    const { init } = this.props

    init()
  }

  componentWillUnmount() {
    const { leave } = this.props

    leave()
  }

  render() {
    const { wrappedComponent: WrappedComponent } = this.props
    const componentProps = omit(this.props, [
      'wrappedComponent',
      'actionCreators',
    ])

    return <WrappedComponent {...componentProps} />
  }
}

FeatureWrapperComponent.propTypes = {
  wrappedComponent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.elementType,
  ]),
  init: PropTypes.func,
  leave: PropTypes.func,
}

FeatureWrapperComponent.defaultProps = {
  init: () => {},
  leave: () => {},
}

const mapStateToProps = () => (state, props) => ({
  ...get(state, `feature-${props.namespace}`, {}),
})

const mapDispatchToProps = (dispatch, props) => {
  if (props.actionCreators) {
    return bindActionCreators(props.actionCreators, dispatch)
  }

  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FeatureWrapperComponent)
